
import React, { useState, useCallback, useEffect } from 'react';
import ConnectView from './views/ConnectView';
import DashboardView from './views/DashboardView';
import * as oauthService from './services/oauthService';

const App: React.FC = () => {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);
  const [isAuthChecked, setIsAuthChecked] = useState<boolean>(false);

  useEffect(() => {
    // Check authentication status on initial load
    setIsAuthenticated(oauthService.isAuthenticated());
    setIsAuthChecked(true);
  }, []);

  const handleConnect = useCallback(async () => {
    const success = await oauthService.signIn();
    if (success) {
      setIsAuthenticated(true);
    }
  }, []);

  const handleDisconnect = useCallback(() => {
    oauthService.signOut();
    setIsAuthenticated(false);
  }, []);

  // Render a loader until the initial authentication status is checked
  if (!isAuthChecked) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-base-100">
        <div className="w-16 h-16 border-4 border-dashed rounded-full animate-spin border-brand-primary"></div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-base-100 text-text-primary font-sans">
      {isAuthenticated ? (
        <DashboardView onDisconnect={handleDisconnect} />
      ) : (
        <ConnectView onConnect={handleConnect} />
      )}
    </div>
  );
};

export default App;
